import { useMemo } from 'react'
import { useScreenTypeContext } from '../state/screenTypeProvider'
import { useMatchTagsAndUsers } from './hooks/useMatchTagsAndUsers'
import { Parking } from './interfaces/parking'
import { ParkingAttachments } from './parkingComponents/parkingAttachment'
import { ParkingCars } from './parkingComponents/parkingCars'
import { ParkingHeader } from './parkingComponents/parkingHeader'
import { ObjectProvider } from './providers/objectProvider'
import { BaseCard } from './subComponents/baseCard'
import { RowInfoAddress } from './subComponents/rowInfoAddress'
import { RowInfoNotes } from './subComponents/rowInfoNotes'
interface ParkingCardProps {
    id?: string
    data?: Parking
    past?: boolean
    border?: boolean
}

export const ParkingCard = ({ id, data, past }: ParkingCardProps) => {
    const { screenType } = useScreenTypeContext()
    const { matchTagsAndUser } = useMatchTagsAndUsers()
    const teamPage = useMemo(() => {
        if (screenType === 'team' || screenType === 'teamMember') return true
        return false
    }, [screenType])
    const cars = useMemo(() => {
        if ((data?.cars?.length ?? 0) === 0) {
            return null
        }
        return data?.cars.filter((car) => {
            if (
                car?.driver?.find((user) => {
                    return matchTagsAndUser(user)
                }) ||
                car?.passengers?.find((user) => {
                    return matchTagsAndUser(user)
                })
            ) {
                return true
            }
            return false
        })
    }, [data?.cars, matchTagsAndUser])
    if (!data) return null

    return (
        <ObjectProvider past={past ?? false} _id={data._id} sectionID="9">
            <BaseCard id={id} past={past}>
                <ParkingHeader parking_name={data.parking_name} />
                {data.address && <RowInfoAddress address={data.address} />}
                {data.additional_info && (
                    <RowInfoNotes notes={data.additional_info} />
                )}

                <ParkingAttachments extra_docs={data.extra_docs} />
                <ParkingCars
                    parkingName={data.parking_name}
                    cars={teamPage ? data.cars ?? [] : cars ?? []}
                />
            </BaseCard>
        </ObjectProvider>
    )
}
